import { Create, Edit, List, Details } from "../Components/index.js";

export default [
    {
        path: "/parade-escape/list",
        component: List,
        name: "parade-escape-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-escape/create",
        component: Create,
        name: "parade-escape-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-escape/:id/edit",
        component: Edit,
        name: "parade-escape-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-escape/:user_id/details",
        component: Details,
        name: "parade-escape-user-details",
        meta: {
            requiresAuth: true,
        },
    },
];
